// extracted by mini-css-extract-plugin
export default {"inner":"Login_inner__Pm+dy","root":"Login_root__Olqcu","imageCol":"Login_imageCol__W6mC8"};